import { createContext, useContext } from "react";
import { SharedValue } from "react-native-reanimated";

interface HorizontalScrollContextValue {
  xOffset: SharedValue<number>;
}

const HorizontalScrollContext =
  createContext<HorizontalScrollContextValue | null>(null);

export const HorizontalScrollProvider = HorizontalScrollContext.Provider;

export const useHorizontalOffset = (): SharedValue<number> | null => {
  const context = useContext(HorizontalScrollContext);
  return context?.xOffset ?? null;
};

export default HorizontalScrollContext;
